<template>
<!-- mobile-menu -->
  <div class="mobile-menu" :class="isOpen ? 'mobile-menu--open' : ''">
    <div class="mobile-menu__backdrop"></div>
    <div class="mobile-menu__body">
      <button class="mobile-menu__close" type="button" @click="$emit('closeMenu', false)">
        <svg width="12" height="12">
          <path d="M10.8,10.8L10.8,10.8c-0.4,0.4-1,0.4-1.4,0L6,7.4l-3.4,3.4c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L4.6,6L1.2,2.6 	c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L6,4.6l3.4-3.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L7.4,6l3.4,3.4 	C11.2,9.8,11.2,10.4,10.8,10.8z" />
        </svg>
      </button>
      <div class="mobile-menu__panel">
        <div class="mobile-menu__panel-header">
          <div class="mobile-menu__panel-title">Menu</div>
        </div>
        <div class="mobile-menu__panel-body">
            <div class="mobile-menu__settings-list" v-if="userIsAuthenticated">
                <div class="mobile-menu__setting" data-mobile-menu-item="">
                    <button class="mobile-menu__setting-button" title="Language" data-mobile-menu-trigger="">
                        <span class="mobile-menu__setting-title">Welcome, {{ billingdetails.billingname }}</span>
                        <span class="mobile-menu__setting-arrow">
                            <svg width="6px" height="9px">
                                <path d="M0.3,7.4l3-2.9l-3-2.9c-0.4-0.3-0.4-0.9,0-1.3l0,0c0.4-0.3,0.9-0.4,1.3,0L6,4.5L1.6,8.7c-0.4,0.4-0.9,0.4-1.3,0l0,0C-0.1,8.4-0.1,7.8,0.3,7.4z"></path>
                            </svg>
                        </span>
                    </button>
                    
                    <div class="mobile-menu__setting-panel" data-mobile-menu-panel="">
                        <div class="mobile-menu__panel mobile-menu__panel--hidden" >
                            <div class="mobile-menu__panel-header">
                                <button class="mobile-menu__panel-back" type="button" @click="backToMain">
                                    <svg width="7" height="11">
                                        <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"></path>
                                    </svg>
                                </button>
                                <div class="mobile-menu__panel-title">Account Login</div>
                            </div>
                            <div class="mobile-menu__panel-body">
                                <ul class="mobile-menu__links">
                                    <li data-mobile-menu-item="">
                                        <button type="button" class="" data-mobile-menu-trigger="" @click.prevent="logout">
                                            Log Out
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="mobile-menu__settings-list" v-if="userIsAuthenticated">
                <div class="mobile-menu__setting" data-mobile-menu-item="">
                  <button class="mobile-menu__setting-button" title="Logout" @click.prevent="logout">
                      <span class="mobile-menu__setting-title">Logout</span>
                  </button>
                </div>
            </div>
            <div class="mobile-menu__divider"></div>

            <div class="mobile-menu__indicators">
            <router-link class="mobile-menu__indicator" to="/account-addresses" v-if="userIsAuthenticated">
              <span class="mobile-menu__indicator-icon">
                <svg width="20" height="20">
                  <path
                    d="M20,20h-2c0-4.4-3.6-8-8-8s-8,3.6-8,8H0c0-4.2,2.6-7.8,6.3-9.3C4.9,9.6,4,7.9,4,6c0-3.3,2.7-6,6-6s6,2.7,6,6 	c0,1.9-0.9,3.6-2.3,4.7C17.4,12.2,20,15.8,20,20z M14,6c0-2.2-1.8-4-4-4S6,3.8,6,6s1.8,4,4,4S14,8.2,14,6z"
                  />
                </svg>
              </span>
              <span class="mobile-menu__indicator-title">Account </span>
            </router-link>

            <router-link class="mobile-menu__indicator" to="/cart">
              <span class="mobile-menu__indicator-icon">
                <svg width="20" height="20">
                  <circle cx="7" cy="17" r="2" />
                  <circle cx="15" cy="17" r="2" />
                  <path
                    d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6 	V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4 	C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                  />
                </svg>
                <span class="mobile-menu__indicator-counter">{{cartquantity}}</span>
              </span>
              <span class="mobile-menu__indicator-title">Cart </span>
            </router-link>

            <router-link class="mobile-menu__indicator" to="/select-parts-drilldown" v-if="has_search_vehicle == true">
              <span class="mobile-menu__indicator-icon">
                <svg width="20" height="20">
                  <path
                    d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1 	c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2 	C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9 	c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0 	c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0 	C15.5,10.2,14,11.3,14,12z"
                  />
                </svg>
              </span>
              <span class="mobile-menu__indicator-title">Select Vehicle </span>
            </router-link>

            </div>
            <div class="mobile-menu__divider"></div>
            <ul class="mobile-menu__links">
                <!-- <li data-mobile-menu-item>
                    <router-link class="main-menu__link" to="/">Home</router-link>
                </li> -->
              <mobile-menu-item 
                    v-for="menu in home_menu"
                    :key="menu.menuid"
                    :hassubmenu="menu.hassubmenu">
                    <router-link data-mobile-menu-trigger :to="menu.url">
                        {{ menu.menuname }} 
                    </router-link>
              </mobile-menu-item>

                <mobile-industrial-menu v-if="industrial_menus.length > 0" :industrial_menus="industrial_menus" @select_vehicle="select_vehicle()"></mobile-industrial-menu>
                <mobile-category-menu :level1="level1" @close="close" :menu_title="specialty_catalog_title"></mobile-category-menu>

                <mobile-menu-item 
                    v-for="menu in primaryMenus"
                    :key="menu.menuid"
                    :hassubmenu="menu.hassubmenu">
                    <router-link data-mobile-menu-trigger :to="menu.url">
                        {{ menu.menuname }}
                        <svg width="7" height="11" v-if="hasSubMenu(menu)">
                            <path
                                d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"
                            />
                        </svg>
                    </router-link>
                    <div class="mobile-menu__links-panel" data-mobile-menu-panel  v-if="menu.hassubmenu === 'Y'">
                        <div class="mobile-menu__panel mobile-menu__panel--hidden">
                            <div class="mobile-menu__panel-header">
                                <button class="mobile-menu__panel-back" type="button">
                                <svg width="7" height="11">
                                    <path
                                    d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"
                                    />
                                </svg>
                                </button>
                                <div class="mobile-menu__panel-title">{{ menu.menuname }}</div>
                            </div>
                            <div class="mobile-menu__panel-body" v-if="menu.hassubmenu === 'Y'">
                                <ul class="mobile-menu__links">
                                    <li data-mobile-menu-item v-for="submenu in subMenus(menu.menuid)" :key="submenu.menuid">
                                        <router-link
                                            data-mobile-menu-trigger
                                            class=""
                                            :to="submenu.url"
                                            v-if="submenu.linktype === 'URL'">
                                            {{ submenu.menuname }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <mobile-translator-menu v-if="menu.pgm === 'load_langs'" :title="menu.menuname"></mobile-translator-menu>
                </mobile-menu-item>
                
            </ul>

            <div class="mobile-menu__spring"></div>
            <div class="mobile-menu__divider"></div>
            <a class="mobile-menu__contacts" href="">
                <div class="mobile-menu__contacts-subtitle">Contact Us</div>
                <div class="mobile-menu__contacts-title">
                    1.888.985.2500 ext.207
                </div>
            </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mobile-menu__setting-button {
    justify-content: left;
  }
</style>

<script>
import MobileCategoryMenu from './MobileCategoryMenu.vue';
import MobileMenuItem from './MobileMenuItem.vue';
import MobileIndustrialMenu from './MobileIndustrialMenu.vue';
import MobileTranslatorMenu from './MobileTranslatorMenu.vue';
import MixinCustomer from '../../../mixins/customer.js';
import { mapGetters } from 'vuex';
import { sfCustom } from '../../../utilities/customs';

export default {
    components: {
        MobileMenuItem, 
        MobileCategoryMenu,
        MobileIndustrialMenu,
        MobileTranslatorMenu
    },
    mixins: [
        MixinCustomer
    ],
  props: {
    level1: {
        type: Array,
        required: true
    },
    menus: {
        type: Array,
        required: true
    },

    industrial_menus: {
        type: Array,
        required: true
    },

    isOpen: {
        type: Boolean,
        required: false
    }
  },
  watch:{
    
  },
  data() {
    return {
      isLoggedIn : false,
      hasLogOut : false,
    };
  },
  computed: {
    
    primaryMenus() {
      const primaries =  this.menus.filter((menu) => {
        if(menu.menuid == 1){
          return false;
        }

        if (this.$store.getters['userIsAuthenticated']) {
          return (menu.primary === "Y" && menu.pgm != 'B2C');
        } else {
          return (menu.primary === "Y" && menu.pgm != 'B2B');
        } 
      });
      return primaries;
    },

    home_menu() {
      const home_item =  this.menus.filter((menu) => {
        if(menu.menuid == 1){
          return true;
        }
      });
      return home_item;
    },

    cartquantity() {
        let totalquantity = 0;
        for (let x in this.cart) {
            totalquantity += parseInt(this.cart[x].quantity);
        }
        return totalquantity;
    },

    specialty_catalog_title() {
      if(this.industrial_menus.length > 0){
        return 'Specialty Catalog';
      }
      return 'Show All Categories';
    },

    has_search_vehicle() {
      if(this.storefront){
        // return sfCustom[this.storefront].search_vehicle;
        return process.env.VUE_SEARCH_VEHICLE;
      }
      return false;
    },

    ...mapGetters("cart", [
        "cart",
        "totals",
        'billingdetails'
    ]),

    ...mapGetters(['userIsAuthenticated', 'customer', 'storefront']),
  },
  methods: {

    hasSubMenu(menu) {
      if(menu.hassubmenu === 'Y' || menu.pgm === 'load_langs')
        return true;
      else
        return false;
    },

    subMenus(parentMenuId) {
      return this.menus.filter((menu) => {
        if (this.$store.getters['userIsAuthenticated']) {
          return (menu.parentmenuid === parentMenuId && menu.pgm != 'B2C');
        } else {
          return (menu.parentmenuid === parentMenuId && menu.pgm != 'B2B');
        }
      });
    },

    select_vehicle() {
      console.log('select vehicle - mobile menu');
      this.$emit('select_vehicle');
    },

    logout() {
        this.$store.dispatch("cart/emptyCart");
        this.$store.dispatch("cart/emptyKits");
        this.$store.dispatch("vehicle/clearSelectedVehicle");
        this.$store.dispatch("setUserAttributes", []);
        this.$store.dispatch("resetCustomerDetails");
        this.$store.dispatch('setSolr_faceted_filter', {});
        this.$store.dispatch('logout');

        this.mx_getCustomerInformation();

        this.totals[0].shippingtotal = 0;
        this.totals[0].ordertotal = 0;
        this.$store.dispatch("cart/totals", this.totals[0]);

        this.$router.push('/home');

        this.$emit('closeMenu', false);
    },

    backToMain() {
      console.log('back to main menu');
    },

    close(){
      console.log('close menu');
      this.$emit('closeMenu', false);
    }
  },


  created() {
      // this.getMenus();
      // this.removeHome = this.menus;
      // this.removeHome.shift();
      // console.log(this.removeHome);

      this.isLoggedIn = this.$store.getters.userIsAuthenticated;
      console.log(this.isLoggedIn);
  },
  updated() {
      // console.log('isOpen = ' + this.isOpen);
      // console.log(this.industrial_menus);

      
  }
}
</script>